/* eslint-disable */
import girl1 from '../assets/svg/testimonials/45.webp'
import girl2 from '../assets/svg/testimonials/47.webp'

export const testimonialsData = [
    {
        id: 1,
        tag: 'خدمات تخصصی پوست و مو',
        headline: 'شگفت‌انگیزها در صنعت زیبایی',
        subtitle: 'با پیشرفته‌ترین تکنولوژی‌های روز دنیا زیبایی خود را کشف کنید',
        image: girl1,
        link: '/service/5'
    },
    {
        id: 2,
        tag: 'برنامه تخصصی کاهش وزن',
        headline: 'جادوی لاغری اصولی',
        subtitle: 'تحت نظر متخصصین تغذیه و پزشکی به وزن ایده‌آل خود برسید',
        image: girl2,
        link: '/service/4'
    }
]
